import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import ClientCoverageHistoryModel from "../../models/client-coverage-history";

export default class ClientCoverageHistoryRepository extends BaseRepository {
  static modelClass = ClientCoverageHistoryModel;
  modelName = "client-coverage-history";

  async query({ caseId }) {
    return await super.query({
      urlPath: `client_coverage/${caseId}/history`,
    });
  }
}
